module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("chapter one")])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("Y")]), _vm._v("ou know it isn’t going to be a good day when you have to choose between food and proper hygiene.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you take the milk off the bill?” I asked the cashier. My cell phone began to ring. I dug around in my bag for it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want it anymore?” The cashier tapped her impossibly long fingernails on the register with one eyebrow raised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. I don’t want the milk,” I repeated. This wasn’t true. I wanted the milk. Eating dry cereal for a week was going to suck. Not to mention having so little dairy in my diet that I would likely end up with a raging case of osteoarthritis when I was old. But until my mom got paid on Friday, there were limited funds in the house, and there’s no way I was going without deodorant. I finally found my phone buried at the very bottom of my bag and yanked it out.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“Sadie, it’s Brendan.” I didn’t need him to tell me his name. Brendan has this habit of yelling into his cell as if it were a tin can on a string.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said. I looked at the new total on the register. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Shit.")]), _vm._v(" “Can you take the toothpaste off too?” We’d have to squeeze a few more days out of the old tube. Now in addition to having brittle bones, I could be toothless. My future was looking brighter and brighter all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman in line behind me gave an exasperated sigh. Screw her. She was probably one of those people who always makes you wait while they count out the exact change from their Coach wallet. I turned around. Great, it was Rebecca Samson and her mom. Their cart was piled high with groceries, including that expensive cheese made by yaks that costs something like twenty dollars for an ounce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gosh, Sadie, do you need to borrow a couple dollars?” Rebecca asked, fighting to keep a smirk off her face. Her mom might have also been trying to smirk, but her face was so Botoxed she was incapable of expression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey! Is that Blow Job Becky I hear? What are you doing hanging with the cheerleader from hell?” Brendan bellowed. His voice carried out of my phone like he was on speaker. Rebecca’s face froze as hard as her mother’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The total’s twenty-two fifteen. How does that work for you?” The cashier tapped her fingernails again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“Hang on, I’m at the store,” I said to Brendan. I plunked my ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("phone down on the conveyor belt and pulled some cash out of my bag. I made sure to spread the two twenty-dollar bills out in a fan shape so they could be clearly seen by the cashier and Blow Job Becky, too.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The cashier snapped her gum when she saw the money. No doubt she wondered why I had nickeled and dimed my bill when I had forty bucks. She handed over my change. I palmed the ten-dollar bill she gave me and, with my thumbnail, pulled a folded five-dollar bill from under my watchband. I made a show of counting the bills. “I’m sorry. I think you didn’t give me enough change.” I held out the two fives, a couple ones, and eighty-five cents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cashier screwed up her face. “I swore I gave you a ten. Sorry.” She pulled another five out of the drawer and handed it to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No problem.” I tucked the money into my bag and took the groceries from her. An extra five bucks was going to come in handy. I could use it to buy milk, but I had more immediate needs than staving off osteoarthritis. I smiled at Rebecca and her Botoxed mom and stepped outside. As soon as the automatic doors closed behind me, it felt like I was slapped in the face with the hot, wet air. It might sound good in theory, but summer sort of sucks unless you can spend it sitting by the ocean with a fruity drink. Spending it in a parking lot with your T-shirt damp and sticking to you isn’t that much fun.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Sorry about that, you caught me in the middle of something,” ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("I said into the phone. I leaned against the warm cinder-block wall. A small kid was standing near me, staring at the pony ride next to the row of gum-ball machines. I tried to ignore him, but he looked like someone had shot his puppy. I sighed and handed him a quarter. He broke into a smile and climbed up on the mechanical horse, leaned forward, and fed the machine the coin. Ah, when joy could be purchased for less than a buck.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you still running that wrong change con for five bucks?” Brendan said. “I keep telling you to up the ante. If you cashed in a hundred-dollar bill, you could easily clear twenty bucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Twenty bucks is more likely to get noticed,” I pointed out. “Not to mention if I start flashing hundred-dollar bills around town, that’s going to seem weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’re doing the small con just to be careful? Are you trying to tell me it has nothing to do with the fact that if the short is less than five dollars, then the cashier doesn’t have to pay it out of their own pocket?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dragged my sneaker on the cement. “Being a cashier at the Save-on-Food Mart is punishment enough. She doesn’t need to cover me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brendan laughed. “Your ethics are getting in the way of the big score, but hey, it’s your choice. What are you up to tonight? I was thinking we could go over to Seattle and grab dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I snorted, knowing full well Brendan’s idea of grabbing dinner. “You buying or is the restaurant?” I asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Now why in the world would I pay?” Brendan wasn’t teasing. ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He actually was incapable of understanding why he should have to pay for anything when he was clever enough to steal it without getting caught.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“While stealing a meal with you sounds like an attractive option, I’m going to have to say no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For a con artist you have a highly overinflated sense of morals,” Brendan said. “Especially when dinner is on the line. We could go for Japanese if you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t call me that. Besides, you hate Japanese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yet another good reason I shouldn’t have to pay for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rolled my eyes. If you wanted to get technical about it, I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" a con artist. I’d learned the tricks of the trade from my dad. Then I taught what I knew to Brendan, who happened to have some sort of freakish natural ability in the area. He was like a con genius savant. However, unlike Brendan, who just loved getting away with something, I preferred to see it as a means to an end, an end that was finally coming to a close. “I can’t go to dinner, I’ve got stuff to do tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people would take a polite brush-off and move on. Brendan was not most people. “I have stuff to get ready for school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going away to college for months. C’mon, a night in the city would be fun.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("I knew down to the exact day (sixty-four, counting today) how soon I would be leaving Bowton Island for college. If I were ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("better at math, I would be counting down the hours in my head. “I want to do some packing,” I said. The truth was, it wouldn’t take me that long to pack. My bedroom was the size of a closet. Even if I took the time to fold each item of my clothing into a tiny origami crane, there’d be no need to start now. The problem was spending time with Brendan felt weird lately. We’d known each other since we were kids, and on an island where 90 percent of the residents measured their wealth in terms of millions, and those of us in the remaining 10 percent measured it by having enough to buy groceries, we were automatic allies. Brendan had been my best friend as long as I could remember.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Brendan was the one who’d realized that the pranks I’d taught him could be used to pull cons to raise cash. He helped me figure out what I needed to do to escape my life. I would always owe him for that. The problem was, he didn’t want me to leave. Or at least he didn’t want me to leave without him, but where I was going there would be no room for him. I was planning to make over my entire life, and that meant leaving the old me behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then there was the uncomfortable realization that Brendan maybe wasn’t thinking of me as just his best friend anymore. There’d been a few awkward moments where I’d caught him staring at me, and at graduation I’d thought he might try to kiss me. And not in a “wow, we’re great friends and we survived high school” kind of way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we could do it another time?” I asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“Fine, but you can’t blow me off forever,” Brendan grumped.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not blowing you off. I’m tired, that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then get some sleep and we’ll do it tomorrow night. No excuses.” Brendan clicked off before I could say anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tossed my cell back into my bag. I pulled out the ten-dollar bill I’d dropped in there after palming it and stuck it in my wallet. Taking a five at a time wasn’t adding up fast, but combined with the money from my part-time job at the hotel, it did add up. Brendan could tease me if he wanted, but I knew that while larger cons might pay off better, they also came with much bigger risks. My dad was a living, breathing example of that. For as long as I could remember, he had been in jail more often than he’d been out. I suspected the correctional officers knew him better than I did. One year when he was on probation, they sent him a birthday card.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Brendan, the point was the con, not the cash. As soon as the money came in, it went right back out. I’d been stockpiling mine. In three and a half weeks I would put most of it down to hold my place at Berkeley. I was going to college, and I planned to leave all of this behind me.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The doors to the grocery swooshed open and Rebecca and her mom came out. Her mom pushed their cart past me as if I didn’t even exist. I suspected she saw me like the help, best ignored unless she needed something. Rebecca glanced over at my Old Navy T-shirt and my cutoff shorts. Somehow she managed to look cool and unfazed by the heat. It was like being ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("really rich also made her immune to humidity and the need to sweat.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice outfit,” she said, her smirk in full force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, that would hurt my feelings if I cared about your opinion,” I said. This was a concept Rebecca had never fully grasped. She felt everyone should want her love and approval. She was also open to ass kissing. It really chafed her fanny that I didn’t care what she thought of me. It must have made her job as the popular mean girl so much less enjoyable when what she said didn’t bother me. She was also apparently unaware of the fact that high school was now over, making her the queen bee of nothing. I noticed a glint of silver on her perfectly pressed polo shirt. “Is that your cheerleading pin?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca fingered the silver megaphone. “It’s my captain’s pin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t decide if it was merely sad or full-on pathetic that she was still wearing it postgraduation. Rebecca was going to grow up to be one of those overly skinny women who hang out at the country club bitching about how their husbands are never around, how their maids don’t scrub the toilets to their satisfaction, and how high school was the best time of their lives. Personally, I was planning on my life getting better from this point forward.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I picked up my bag of groceries. “You have a good rest of the summer,” I called over my shoulder at her as I walked away. Being nice to Rebecca would screw with her head more than any sarcastic comeback. I tucked my bag into the basket attached to ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("the back of my scooter. Rebecca might mock my secondhand clothes and Brendan might make fun of my five-dollar cons, but in sixty-four days none of it would matter.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Unlike Rebecca, I didn’t plan to look back on high school with fondness. I didn’t plan to look back on it at all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 69
// module chunks = 0